function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 4C12 4.55 11.55 5 11 5C10.91 5 10.825 4.99 10.745 4.965L8.965 6.74C8.99 6.82 9 6.91 9 7C9 7.55 8.55 8 8 8C7.45 8 7 7.55 7 7C7 6.91 7.01 6.82 7.035 6.74L5.76 5.465C5.68 5.49 5.59 5.5 5.5 5.5C5.41 5.5 5.32 5.49 5.24 5.465L2.965 7.745C2.99 7.825 3 7.91 3 8C3 8.55 2.55 9 2 9C1.45 9 1 8.55 1 8C1 7.45 1.45 7 2 7C2.09 7 2.175 7.01 2.255 7.035L4.535 4.76C4.51 4.68 4.5 4.59 4.5 4.5C4.5 3.95 4.95 3.5 5.5 3.5C6.05 3.5 6.5 3.95 6.5 4.5C6.5 4.59 6.49 4.68 6.465 4.76L7.74 6.035C7.82 6.01 7.91 6 8 6C8.09 6 8.18 6.01 8.26 6.035L10.035 4.255C10.01 4.175 10 4.09 10 4C10 3.45 10.45 3 11 3C11.55 3 12 3.45 12 4Z",
  fill: "#878889"
});

var SvgRating = function SvgRating(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRating, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rating.6f5013bb.svg";
export { ForwardRef as ReactComponent };